<mat-card class="selectable-card"
          [class.is-selected]="checked"
          (click)="onClick()">
  <mat-card-content class="component-html-wrapper" #htmlWrapper [innerHTML]="sanitizeHtml(option.display!)"></mat-card-content>
</mat-card>
